// extracted by mini-css-extract-plugin
module.exports = {"link":"authNav_link__iHl0R","activeLink":"authNav_activeLink__sYfiI"};